"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Preconfigured = ({ manifest }) => (react_1.default.createElement("div", { className: "p-4 bg-gray-100 text-md" },
    manifest?.description && (react_1.default.createElement("p", { className: "mb-0 text-center pb-2 mb-2 border-b border-b-gray-300" }, manifest.description)),
    react_1.default.createElement("p", { className: "text-center italic text-gray-600" }, "This component is preconfigured and can not be edited.")));
exports.default = Preconfigured;
